import EventGroupDetailLive from "./EventGroupDetailLive";

export default EventGroupDetailLive;
